import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function PonudeLoginPage() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => { document.title = "MAK"; }, []);

    useEffect(() => {
        if (!loading && user) navigate("/ponude", { replace: true });
    }, [user, loading, navigate]);

    const handleLogin = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/ponude";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--paper-2))] px-6">
            <div className="w-full max-w-md bg-white border border-[hsl(var(--line))] p-10 shadow-sm">
                <div className="mb-8">
                    <span className="text-[hsl(var(--accent))] font-bold tracking-widest text-xs">ALU-OGRADE.BA</span>
                    <h1 className="mt-3 text-3xl font-bold leading-tight">Informativne ponude</h1>
                    <p className="mt-2 text-sm text-[hsl(var(--muted-ink))]">
                        Prijavite se Google nalogom da pristupite generatoru ponuda.
                    </p>
                </div>

                <button
                    onClick={handleLogin}
                    data-testid="google-login-btn"
                    className="w-full flex items-center justify-center gap-3 bg-[hsl(var(--ink))] text-white py-3.5 px-5 hover:bg-[hsl(var(--accent))] transition-colors font-medium"
                >
                    <svg width="20" height="20" viewBox="0 0 48 48">
                        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z" />
                        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
                        <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.5 2.4-7.2 2.4-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
                        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.2-4.1 5.6l6.2 5.2c-.4.4 6.6-4.8 6.6-14.8 0-1.3-.1-2.3-.4-3.5z" />
                    </svg>
                    Prijava sa Google
                </button>

                <p className="mt-6 text-xs text-[hsl(var(--muted-ink))]">
                    Pristup je dozvoljen samo ovlaštenim korisnicima (info@pelesic.com).
                </p>

                <a href="/" className="block mt-8 text-xs text-[hsl(var(--muted-ink))] hover:text-[hsl(var(--ink))]">
                    ← Nazad na alu-ograde.ba
                </a>
            </div>
        </div>
    );
}
